import apiClient from '../clienteFebosAPI';

const RESOURCE = '/v2/empresas';

export const getProfiles = (companyId, payload = {}) => {
  const params = apiClient.queryParamsComponent(payload);
  return apiClient.get(
    `${RESOURCE}/${companyId}/perfiles?${params}`,
    { operacionId: 'io.perfiles.listar' }
  );
};
